/**
 * Local Storage Keys
 *
 * Keys used for storing data in the browser's local storage.
 * Prefix all keys with 'geoforge:' to avoid conflicts with other applications.
 */
export const LOCAL_STORAGE = {
  WORKSPACE_ID: 'geoforge:default_workspace_id',
  MAPLIBRE_PREFERENCES: 'geoforge:maplibre-preferences',
  OPEN_LEGEND_ITEMS: (mapId: string, userDisplayName?: string | null) =>
    `geoforge:open-legend-items-${mapId}-${userDisplayName ?? 'unknown'}`,
  OPEN_LAYER_GROUPS: (mapId: string, userDisplayName?: string | null) =>
    `geoforge:open-layer-groups-${mapId}-${userDisplayName ?? 'unknown'}`,
  LEGEND_PANEL_OPEN: (mapId: string, userDisplayName?: string | null) =>
    `geoforge:legend-panel-open-${mapId}-${userDisplayName ?? 'unknown'}`,
  LEGEND_PANEL_HEIGHT: (mapId: string, userDisplayName?: string | null) =>
    `geoforge:legend-panel-height-${mapId}-${userDisplayName ?? 'unknown'}`,
  MAP_SETTINGS: (mapId: string, userId: string) => `geoforge:map-settings-${mapId}-${userId}`,
  LAYER_FILTERS: (mapId: string, userId: string) => `geoforge:layer-filters-${mapId}-${userId}`,
  SEARCH_ORDER: (workspaceId: string) => `geoforge:search-order-${workspaceId}`,
  FREE_REPORT_INTAKE: 'geoforge:freeReport.intake',
} as const;

/**
 * Application Settings
 *
 * Default settings and configuration values and feature Flags.
 */
export const APP_SETTINGS = {
  CURRENT_STYLE_VERSION: '2.2.0' as const,
  ENABLE_GOOGLE_AUTH: process.env.NEXT_PUBLIC_ENABLE_GOOGLE_AUTH === 'true',
  ENABLE_MAP_AI: process.env.NEXT_PUBLIC_ENABLE_MAP_AI === 'true',
  ENABLE_EMBEDS: process.env.NEXT_PUBLIC_ENABLE_EMBEDS === 'true',
  // Cloudflare Turnstile site key for the auth forms; empty renders no widget. `next dev` falls back
  // to Cloudflare's always-passes test key, the pair of the test secret local GoTrue enforces with
  // (supabase/config.toml). Deployed builds never do, so their key must be set explicitly.
  TURNSTILE_SITE_KEY:
    process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY ||
    (process.env.NODE_ENV === 'development' ? '1x00000000000000000000AA' : ''),
  EXTERNAL_TILE_LAYER_IDS: new Set<string>(
    (process.env.NEXT_PUBLIC_EXTERNAL_TILE_LAYER_IDS || '').split(',').filter(Boolean)
  ),
} as const;
